import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import style from './index.css';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';

const Foot = ({ content }) => {
    const { thumbnail, title, bref } = content.footKeyword;
    const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';
    
    const wxLaunchHackData = {
        callAppConfig: {
            docType: 'news3hoursList',
            pid: `https://${ nineDomain }/news3hoursList`,
            kind: 'inter_3hfx02',
            noKindFrom: 1,
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7199259265366402048',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9089',
        },
        statisticsConfig: {
            behavior: 'action',
            type: '3hourbtm',
        },
    };

    return (
        <div className={style.footouterbox}>
            <Chip id="260664" type="struct" title="页底维护" groupName="页底维护">
                <div className={style.foot}>
                    <WxLaunchHack content={wxLaunchHackData} />
                    <div className={style.leftbar}>
                        <img src={thumbnail} className={style.avatar} />
                        <div className={style.text}>
                            <div className={style.textover}>{title}</div>
                            <div className={style.textover}>{bref}</div>
                        </div>
                    </div>
                    <div className={style.openbtn}>打开</div>
                </div>
            </Chip>
        </div>
    );
};

Foot.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Foot);
